import vm from "../main";
import axios from "./PointrCloudAxios";
import ToastHelpers from "@/helpers/ToastHelpers";
import AuthHelpers from "@/helpers/AuthHelpers";

export default class ClientService {
  static async getClients() {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.get("/content/draft/clients");
    } catch (error) {
      AuthHelpers.logout();
      window.location.href = "/signin";
      console.error(error);
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    if (!response?.data) {
      AuthHelpers.logout();
      window.location.href = "/signin";
    }
    return response?.data;
  }

  static async getPublishedClient(clientInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.get(`/content/published/clients/${clientInternalIdentifier}`);
    } catch (error) {
      console.error(error);
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    return response?.data;
  }

  static async updateClient(client, clientInternalIdentifier, messageKey) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.put(`/content/draft/clients/${clientInternalIdentifier}`, client);
    } catch (error) {
      console.error(error);
      ToastHelpers.createServiceErrorToast(
        error?.response?.data,
        error?.response?.data?.message || `${vm.$t(messageKey + ".failed")}` || `${vm.$t("contents.fail-message")}`
      );
      return error?.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    ToastHelpers.createSuccessToast(
      messageKey ? `${vm.$t(messageKey)}` : `${client.name} ${vm.$t("contents.updated")}`
    );
    return response?.data;
  }

  static async activateAnalytics(clientInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.post(`/content/draft/clients/${clientInternalIdentifier}/analytics/activate`);
    } catch (error) {
      console.error(error);
      ToastHelpers.createServiceErrorToast(
        error?.response?.data,
        error?.response?.data?.message || vm.$t(`analytics.activation-requested-fail`)
      );
      return error?.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    return response?.data;
  }

  static async getSitesSummary(clientInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.get(`/content/draft/clients/${clientInternalIdentifier}/sites/summary`);
    } catch (error) {
      console.error(error);
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    return response?.data;
  }
}
